import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Navigations from "../../config/navbar";
import Footer from "../../components/footer";
import firebase from "../../config/firebase";
import ReactHtmlParser from "react-html-parser";
import githubLogo from "../../images/github-p-500.png";
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    firebase
      .database()
      .ref("Projects")
      .on("value", (snapshot) => {
        snapshot.forEach((data) => {
          var movie = data.val();
          // console.log(params.id)
          // console.log(movie.newPostKey)
          if (movie.newPostKey === params.id) {
            this.setState({
              body: movie.body,
              buttonLink: movie.buttonLink,
              category: movie.category,
              createAt: movie.createAt,
              currentUser: movie.currentUser,
              downloadURL: movie.downloadURL,
              githubLink: movie.githubLink,
              headingName: movie.headingName,
              newPostKey: movie.newPostKey,
            });
          }
        });
      });
  }

  render() {
    const {
      body,
      buttonLink,
      category,
      createAt,
      currentUser,
      downloadURL,
      githubLink,
      headingName,
      newPostKey,
    } = this.state;
    const html = body;
    return (
      <div>
        <Navigations />
        <div
          style={{
            borderBottom: "3px solid black",
            textAlign: "center",
            marginTop: "5rem",
            // backgroundColor: 'teal',
            padding: 10,
          }}
        >
          <h1 style={{ color: "rgb(118, 102, 223)" }}>{headingName}</h1>
        </div>
        <section class="py-5">
          <div class="container">
            {/* <h2>Description</h2> */}
            <h4>Description: {ReactHtmlParser(html)}</h4>
            <div style={{ marginBottom: 10 }}>
              <a
                href={buttonLink}
                target="_blank"
                rel="noopener noreferrer"
                type="button"
                class="btn btn-outline-primary"
                style={{
                  backgroundColor: "rgb(118, 102, 223)",
                  color: "white",
                  marginRight: 10,
                }}
              >
                View
              </a>
              <a href={githubLink} target="_blank" rel="noopener noreferrer">
                <img
                  alt="githublogo"
                  style={{
                    justifyContent: "flex-start",
                    cursor: "pointer",
                    height: 40,
                  }}
                  src={githubLogo}
                />
              </a>
            </div>
            <img src={downloadURL} style={{ height: "100%", width: "100%" }} />
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

Contact.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(Contact);
